import { Box, Typography, useMediaQuery } from "@mui/material";

/**
 * Rounds date up to nearest hour
 * @param {Date} date
 * @returns Rounded Date
 */
function roundDateUpToNearestHour(date) {
    const roundedDate = new Date(date);
    // If minutes or seconds or milliseconds are non-zero, we need to round up
    if (
        roundedDate.getMinutes() > 0 ||
        roundedDate.getSeconds() > 0 ||
        roundedDate.getMilliseconds() > 0
    ) {
        roundedDate.setHours(roundedDate.getHours() + 1);
        roundedDate.setMinutes(0, 0, 0);
    } else {
        // Already on the hour
        roundedDate.setMinutes(0, 0, 0);
    }
    return roundedDate;
}

/**
 * Gets all the hours between the first and last time
 * @param {Date} firstTime
 * @param {Date} lastTime
 * @returns Array of Dates with the hours
 */
function getTimes(firstTime, lastTime) {
    const times = [];
    let cur = roundDateUpToNearestHour(firstTime);
    while (cur <= lastTime) {
        times.push(cur);
        cur = new Date(cur);
        cur.setHours(cur.getHours() + 1);
    }
    // console.log(times);
    return times;
}

export default function ScheduleTimes({ scheduleStartTime, scheduleEndTime }) {
    const isVertical = useMediaQuery('(max-width:750px)');

    return (
        <Box
            id="ScheduleTimes"
            sx={{
                height: "100%",
                minWidth: "5.5em",
                borderRight: "2px var(--mui-palette-primary-main) solid",
                marginRight: "1em",
                position: "relative",
                "@media (max-width: 750px)": {
                    minWidth: "1em",
                },
            }}
        >
            {getTimes(scheduleStartTime, scheduleEndTime).map((time) => (
                <Typography
                    key={time.getTime()}
                    sx={{
                        position: "absolute",
                        right: "1em",
                        top: `${
                            ((time - scheduleStartTime) / (scheduleEndTime - scheduleStartTime)) * 100
                        }%`,
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}
                >
                    {time.toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: isVertical ? undefined : "2-digit",
                        hour12: true,
                    })}
                </Typography>
            ))}
        </Box>
    );
}
